import type {
  ComponentValueResponse,
  ResolveIdentityConflictRequest,
  ResolveIdentityConflictResponse,
  SaveComponentValueResponse,
} from "@repo/shared/types";
import { get, post } from "../_client";

const BASE = "/internal/flow-instances";

export function getFlowInstanceValue(instanceId: string) {
  return get<ComponentValueResponse>(
    `${BASE}/${instanceId}/sumsub-verification/flow-instance-value`,
  );
}

export function saveFlowInstanceValue(instanceId: string, data: unknown) {
  return post<SaveComponentValueResponse>(
    `${BASE}/${instanceId}/sumsub-verification/flow-instance-value`,
    data,
  );
}

/**
 * Webhook fallback: pull the applicant's latest state from Sumsub, persist it,
 * and return the (possibly updated) value. Backs the manual "refetch" action.
 */
export function refetchFromSumsub(instanceId: string) {
  return post<ComponentValueResponse>(`${BASE}/${instanceId}/sumsub-verification/refetch`);
}

/** QL-f — the identity conflicts raised by the scanned document, and their state. */
export function getIdentityConflicts(instanceId: string, subjectId?: string) {
  const query = subjectId ? `?subjectId=${encodeURIComponent(subjectId)}` : "";
  return get<ResolveIdentityConflictResponse>(
    `${BASE}/${instanceId}/sumsub-verification/identity-conflict${query}`,
  );
}

/** Answer one conflicting field: correct our record, or accept the difference. */
export function resolveIdentityConflict(
  instanceId: string,
  payload: ResolveIdentityConflictRequest,
) {
  return post<ResolveIdentityConflictResponse>(
    `${BASE}/${instanceId}/sumsub-verification/identity-conflict`,
    payload satisfies ResolveIdentityConflictRequest,
  );
}
